import { styled, useTheme } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import * as React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AssignmentIcon from '@mui/icons-material/Assignment';
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Select from '@mui/material/Select';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import ButtonBase from '@mui/material/ButtonBase';
import Link from '@mui/material/Link';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import emailjs from "emailjs-com";
import { ScatterChart, XAxis, YAxis, ZAxis, Tooltip, Scatter, Legend, CartesianGrid, ReferenceArea } from 'recharts';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot, query, addDoc, where, orderBy, doc, updateDoc, limit } from 'firebase/firestore'
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

// Connect to current firebase project
const firebaseApp = initializeApp({
  apiKey: "AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY",
  authDomain: "ambient-systems.firebaseapp.com",
  databaseURL: "https://ambient-systems-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ambient-systems",
  storageBucket: "ambient-systems.appspot.com",
  messagingSenderId: "1001740093061",
  appId: "1:1001740093061:web:b516ca06c0e80199b90bec"
});
const firestore = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

/* Identify the current user */
const user_email = window.localStorage.getItem('user_email');

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

const drawerWidth = 220;

// Main function of this page
export default function MachineLearningPage() {
  const theme = useTheme()
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const [instance, setInstance] = useState([])
  const [feed, setFeed] = useState([])
  const [ID, setID] = useState();
  const [modelDetail, setModelDetail] = useState();
  const [modelSelected, setModelSelected] = useState([])
  const [modelFileId, setModelFileId] = useState([])

  useEffect(() => {
      const idQuery = query(
          collection(firestore, 'models'),
          where('email', '==', user_email),
          limit(1),
          orderBy('modelId', 'desc')
      );
      onSnapshot(idQuery, snapshot => {
          const t = (snapshot.docs.map(doc => ({ id: doc.data().modelId })))
          if (!t[0]) {
              setID('0')
          } else {
              setID(JSON.stringify(t[0].id))
          }
      })
  }, [])

  useEffect(() => {
    const modelQuery = query(
      collection(firestore, 'models'),
      where('email', '==', user_email),
      orderBy("modelId")
    );
    const unsubscribe = onSnapshot(modelQuery, snapshot => {
      setInstance(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
    })

    return () => {
      unsubscribe()
    }
  }, [])

  useEffect(() => {
    const connectorQuery = query(
        collection(firestore, 'connectors'),
        where('user_email', '==', user_email)
    );
    const unsubscribe = onSnapshot(connectorQuery, snapshot => {
        setFeed(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
    })

    return () => {
        unsubscribe()
    }
  }, [])

  useEffect(() => {
    const modelQuery = query(
        collection(firestore, 'models'),
        where('email', '==', user_email),
        where('modelId', '==', Number(modelSelected))
    );
    const unsubscribe = onSnapshot(modelQuery, snapshot => {
      setModelDetail(snapshot.docs.map(doc => doc.data()))
      setModelFileId(snapshot.docs.map(doc => doc.id))
    })

    return () => {
        unsubscribe()
    }
    }, [modelSelected])

  const [connection1, setConnection1] = useState(false)
  const [connection2, setConnection2] = useState(false)
  const [connection3, setConnection3] = useState(false)
  const [connection4, setConnection4] = useState(false)
  const [connection5, setConnection5] = useState(false)
  const [modelChoice, setModelChoice] = useState([])
  const [feedChoice, setFeedChoice] = useState([])
  const [feedId, setFeedId] = useState([])
  const [fileId, setFileId] = useState([]);
  const [modelList, setModelList] = useState([])
  const [modelList2, setModelList2] = useState([])
  const [scientist, setScientist] = useState([])
  const [modify1, setModify1] = useState(false)
  const [modify2, setModify2] = useState(false)
  const [modify3, setModify3] = useState(false)
  const [feedDoc, setFeedDoc] = useState(false)
  const [expert, setExpert] = useState([])
  const [specific, setSpecific] = useState([])
  const [specific2, setSpecific2] = useState([])
  const [fileName, setFileName] = useState([])

  useEffect(() => {
    const connectorQuery = query(
        collection(firestore, 'connectors'),
        where('user_email', '==', user_email),
        where('name', '==', feedChoice)
    );
    const unsubscribe = onSnapshot(connectorQuery, snapshot => {
        setFileId(snapshot.docs.map(doc => doc.id))
        setModelList(snapshot.docs.map(doc => doc.data().models))
        setFeedId(snapshot.docs.map(doc => doc.data().id))
        setFileName(snapshot.docs.map(doc => doc.data().file))
    })

    return () => {
        unsubscribe()
    }
  }, [feedChoice])

  useEffect(() => {
    const connectorQuery = query(
        collection(firestore, 'connectors'),
        where('user_email', '==', user_email),
        where('id', '==', Number(modify3))
    );
    const unsubscribe = onSnapshot(connectorQuery, snapshot => {
        setFeedDoc(snapshot.docs.map(doc => doc.id))
        setModelList2(snapshot.docs.map(doc => doc.data().models))
    })

    return () => {
        unsubscribe()
    }
  }, [modify3])

  useEffect(() => {
    const expertQuery = query(
        collection(firestore, 'experts')
    );
    const unsubscribe = onSnapshot(expertQuery, snapshot => {
        setExpert(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
    })

    return () => {
        unsubscribe()
    }
  }, [])

  useEffect(() => {
    const expertQuery = query(
        collection(firestore, 'experts'),
        where("name", "==", scientist)
    );
    const unsubscribe = onSnapshot(expertQuery, snapshot => {
        setSpecific(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
    })

    return () => {
        unsubscribe()
    }
  }, [scientist])

  useEffect(() => {
    const expertQuery = query(
        collection(firestore, 'experts'),
        where("name", "==", modify2)
    );
    const unsubscribe = onSnapshot(expertQuery, snapshot => {
        setSpecific2(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
    })

    return () => {
        unsubscribe()
    }
  }, [modify2])

  const handleRequest = () => {
    setConnection1(true)
  }

  const closeRequest1 = () => {
    setConnection1(false)
    setModelChoice([])
  }

  const handleNext1 = () => {
    setConnection1(false)
    setConnection2(true)
  }

  const closeRequest2 = () => {
    setConnection2(false)
    setModelChoice([])
    setFeedChoice([])
  }

  const handleNext2 = () => {
    setConnection2(false)
    setConnection3(true)
  }

  const closeRequest3 = () => {
    setConnection3(false)
    setModelChoice([])
    setFeedChoice([])
    setScientist([])
  }

  const closeRequest4 = () => {
    setConnection4(false)
    setModelSelected([])
  }

  const closeRequest5 = () => {
    setConnection5(false)
    setModify1([])
    setModify2([])
    setModelSelected([])
  }

  const handleNext3 = () => {
    if (modelSelected == "") {
      alert("Please choose 1")
      return 
    }

    if (modelDetail) {
        setModify1(modelDetail[0].name)
        setModify2(modelDetail[0].dataExpert)
        setModify3(modelDetail[0].feed)
        setConnection4(false)
        setConnection5(true)
    }
  }

  function formatDate() {
    var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
  }

  function handleSubmit() {
    if (modelChoice == "" || feedChoice == "" || scientist == "") {
      alert("Some value is missed! Please select all three values.")
      return 
    }

    var address = ""
    getDownloadURL(ref(storage, user_email + '/' + fileName[0]))
    .then((url) => {
      address = url
    })

    var tmpModels = modelList[0]
    if (tmpModels.includes(modelChoice)) {
      alert("You have added this model to the current data feed!")
    } else {
      tmpModels.push(modelChoice)
      updateDoc(doc(firestore, 'connectors/'+fileId), {models: tmpModels})
                .then(() => {
                    alert("Set up Successfully! We will start to handle your request.")
                    closeRequest3()

                    emailjs.send("teamService","template_cqyfsfh",{
                      subject: "User requested a new ML technique to his certain data feed!",
                      name: "ML technique is " + modelChoice,
                      email: "from " + user_email,
                      message: "The feed is " + feedChoice + ". ID: " + fileId + ". Please check in the firestore \'connectors\' collection. And the file address is: " + address,
                    }, "r87tnpnYE2FXwhAzx");

                    const email = user_email
                    const content = "Requested a ML technique : " + modelChoice
                    const date = formatDate()
                    const time = new Date()
                    addDoc(collection(firestore, 'alerts'), {email, content, date, time})

                    const modelId = Number(ID) + 1
                    const name = modelChoice
                    const dataExpert = scientist
                    const dateRequested = new Date()
                    const dateLive = 'Under development'
                    const dataConnection = 'Under development'
                    const outputId = 'In progress'
                    const status = 'In progress'
                    const feed = Number(feedId)
                    addDoc(collection(firestore, 'models'), {modelId, name, dataExpert, dateRequested, dateLive, dataConnection, outputId, status, email, feed })
                })
                .catch((error) => {
                    console.log(error.message)
                    alert(error.message)
                });
    }
  }

  function handleModify() {
    setConnection4(true)
  }

  function handleModifySubmit() {
    if (modify1 == '' || modify2 == '') {
      alert("Some value is empty!")
    } else {
      var tmpModels = modelList2[0]
      if (tmpModels.includes(modify1)) {
        alert("You have added this model to the current data feed!")
      } else {
        tmpModels.push(modify1)
        var index = tmpModels.indexOf(modelDetail[0].name)
        tmpModels.splice(index, 1)
        if (window.confirm("Are you sure that you want to modify the information? They will cover the previous records.")) {
          updateDoc(doc(firestore, 'models/'+modelFileId), {name: modify1, dataExpert: modify2})
          .then(() => {
              alert("Updated!")
              closeRequest5()
  
              emailjs.send("teamService","template_cqyfsfh",{
                subject: "User modified the infomation of one of his model!",
                name: "ML technique is " + modify1,
                email: "from " + user_email,
                message: "The data expert would be " + modify2 + ". Instance ID is : " + modelFileId + ". Please check in the firestore \'models\' collection",
              }, "r87tnpnYE2FXwhAzx");
  
              updateDoc(doc(firestore, 'connectors/'+feedDoc), {models: tmpModels})
          })
          .catch((error) => {
              console.log(error.message)
              alert(error.message)
          });
        }
      }
    }
  }

  const [payWall, setPayWall] = useState(false)
    useEffect(() => {
        const authQuery = query(
        collection(firestore, 'users'),
        where('username', '==', user_email),
        );
        onSnapshot(authQuery, snapshot => {
            const t = (snapshot.docs.map(doc => ({ data: doc.data().isUpgrade })))
            if (!t[0].data) {
                setPayWall(true)
            }
        })
    }, [])

  return (
    <Box sx={{ display: "flex", height: "100%" }}>
        {/* Sub-Sidebar layout */}
        <Drawer variant="permanent" open={open} >
          <Toolbar
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              px: [1],
              height: 66,
            }}
          >
            <IconButton onClick={toggleDrawer} sx={{ mr: 1 }}>
              {open ? (
                <KeyboardDoubleArrowLeftIcon />
              ) : (
                <KeyboardDoubleArrowRightIcon />
              )}
            </IconButton>
          </Toolbar>

          <Divider />

          {/* Sub-bar Navigations */}
          <List component="nav">
            <ListItemButton href="/Dashboard/ML" >
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Summary" />
            </ListItemButton>

            <ListItemButton href="/Dashboard/ML/Requests">
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Requests" />
            </ListItemButton>

            <ListItemButton href="/Dashboard/ML/Assembly" >
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Assembly Line" />
            </ListItemButton>

            <ListItemButton href="/Dashboard/ML/Active">
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Active" />
            </ListItemButton>

            <ListItemButton href="/Dashboard/Output" >
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Output" />
            </ListItemButton>

            <ListItemButton>
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Destination" />
            </ListItemButton>
          </List>
        </Drawer>

          {/* Main space of page*/}
          {payWall? (
            <Box sx={{ height: '100%', width: '100%' }}  display="flex" justifyContent="center" alignItems="center">
                This service is limited to PRO version. Please upgrade your version by clicking the "UPGRADE" button on the top right.
            </Box>
            ) : (
          <Box>
            {/* Title */}
            <Box sx={{ width: "100%" }}>
                <Typography
                  component="h1"
                  variant="subtitle1"
                  color="inherit"
                  noWrap
                  sx={{ flexGrow: 1, mt: 3, ml: 8 }}
                >
                  Ambient / Machine Learning / Summary
                </Typography>
                <Typography
                  component="h1"
                  variant="h4"
                  color="inherit"
                  noWrap
                  sx={{ flexGrow: 1, ml: 8, mb: 2 }}
                >
                  Summary
                </Typography>
            </Box>

            <Box sx={{ ml: 8.5, mt: 3, display: 'flex' }}>
                <Typography
                    component="h1"
                    variant="subtitle1"
                    color="inherit"
                    noWrap
                    >
                    Request one of the ML techniques: 
                </Typography>
                <Button
                    variant="contained"
                    color="secondary"
                    sx={{ ml: 2, mt: -0.5, borderRadius: 5 }}
                    position="absolute"
                    onClick={handleRequest}
                >
                    Request
                </Button>
                <Button
                    variant="contained"
                    color="warning"
                    sx={{ mt: -0.5, ml: 4, borderRadius: 5 }}
                    position="absolute"
                    onClick={handleModify}
                >
                    Modify
                </Button>
            </Box>

                <Box sx={{ ml: 8, mt: 1 }}>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 800 }} aria-label="model summary table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="right">Model ID</TableCell>
                          <TableCell align="right">Model Name</TableCell>
                          <TableCell align="right">Data Expert</TableCell>
                          <TableCell align="right">Date Requested</TableCell>
                          <TableCell align="right">Date Live</TableCell>
                          <TableCell align="right">Data Connections</TableCell>
                          <TableCell align="right">Outputs ID</TableCell>
                          <TableCell align="right">Model Status</TableCell>
                          <TableCell align="right">Feed ID</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {instance?.map((row) => (
                          <TableRow
                            key={row.data.modelId}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              {row.data.modelId}
                            </TableCell>
                            <TableCell align="right">{row.data.name}</TableCell>
                            <TableCell align="right">{row.data.dataExpert}</TableCell>
                            <TableCell align="right">{row.data.dateRequested.toDate().toString()}</TableCell>
                            <TableCell align="right">{row.data.dateLive}</TableCell>
                            <TableCell align="right">{row.data.dataConnection}</TableCell>
                            <TableCell align="right">{row.data.outputId}</TableCell>
                            <TableCell align="right">{row.data.status}</TableCell>
                            <TableCell align="right">{row.data.feed}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

            <Dialog open={connection1} onClose={closeRequest1} maxWidth={"md"} fullWidth={true}>
                <DialogTitle>Step1</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please select one of the AI techniques:
                    </DialogContentText>
                    
                    <Box sx={{ minHeight: 100, ml: 10, mt: 10 }}>
                      <Box sx={{ display: 'flex', mt: 5 }}>
                        <Typography variant="h7">Select your type of request:</Typography>
                        <FormControl variant= "standard" sx={{ ml: 3, mt: -1 }}>
                          <Select native defaultValue="" label="model" disableUnderline
                              theme={theme}
                              sx={{
                                  borderRadius: 25,
                                  backgroundColor: theme.palette.background.default,
                                  padding: "6px 15px",
                              }}
                              value={modelChoice}
                              onChange={(e) => {setModelChoice(e.target.value)}}>
                              
                              <option value="">Active Models:</option>
                              <option value="Climate Risk Modelling (T&P)">Climate Risk Modelling (T&P)</option>
                              <option value="Investment Decision Modelling">Investment Decision Modelling</option>
                              <option value="Construction Material Selection & Procurement">Construction Material Selection & Procurement</option>
                              <option value="Customized Building Automation">Customized Building Automation</option>
                              <option value="Retrofit Evaluation">Retrofit Evaluation</option>
                              <option value="DER Deployment Feasibility">DER Deployment Feasibility</option>
                              <option value="Tenant Sentiment Analysis">Tenant Sentiment Analysis</option>
                              <option value="Lease Pricing Prediction">Lease Pricing Prediction</option>
                              <option value="Retrofit Analysis">Retrofit Analysis</option>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={closeRequest1}>Cancel</Button>
                    <Button onClick={handleNext1}>Next</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={connection2} onClose={closeRequest2} maxWidth={"md"} fullWidth={true}>
                <DialogTitle>Step2</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please attach one of your data feed to your model:
                    </DialogContentText>
                    
                    <Box sx={{ minHeight: 100, ml: 7, mt: 10 }}>
                      <Box sx={{ display: 'flex', mt: 5 }}>
                        <Typography variant="h7">Select your feed that would attach this request:</Typography>
                        <FormControl variant= "standard" sx={{ ml: 3, mt: -1 }}>
                          <Select native defaultValue="" label="feed" disableUnderline
                              theme={theme}
                              sx={{
                                  borderRadius: 25,
                                  backgroundColor: theme.palette.background.default,
                                  padding: "6px 15px",
                              }}
                              value={feedChoice}
                              onChange={(e) => {setFeedChoice(e.target.value)}}>
                              
                              <option value="">Your Feeds:</option>
                              {feed?.map((row) => (
                                  <option value={row.data.name}>{row.data.name}</option>
                              ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={closeRequest2}>Cancel</Button>
                    <Button onClick={handleNext2}>Next</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={connection3} onClose={closeRequest3} maxWidth={"sm"} fullWidth={true}>
                <DialogTitle>Step3</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please assign this task to one scientist:
                    </DialogContentText>
                    
                    <Box sx={{ minHeight: 100, ml: 10, mt: 10 }}>
                      <Box sx={{ display: 'flex', mt: 5 }}>
                        <Typography variant="h7">Select your scientist:</Typography>
                        <FormControl variant= "standard" sx={{ ml: 3, mt: -1 }}>
                          <Select native defaultValue="" label="feed" disableUnderline
                              theme={theme}
                              sx={{
                                  borderRadius: 25,
                                  backgroundColor: theme.palette.background.default,
                                  padding: "6px 15px",
                              }}
                              value={scientist}
                              onChange={(e) => {setScientist(e.target.value)}}>
                              
                              <option value=""></option>
                              {expert?.map((row) => (
                                <option value={row.data.name}>{row.data.name}</option>
                              ))}
                          </Select>
                        </FormControl>
                      </Box>
                      {scientist && 
                            <Box>
                              {specific?.map((row) => (
                                <FormControl>
                                <Typography variant="h7">Talent: {row.data.talent}</Typography>
                                <Typography variant="h7">Work year: {row.data.year} year</Typography>
                                <Typography variant="h7">Age: {row.data.age}</Typography>
                                <Typography variant="h7">background: {row.data.college}</Typography>
                                <Typography variant="h7">LinkedIn: <a href={row.data.linkedin}>{row.data.linkedin}</a></Typography>
                                </FormControl>
                              ))}
                            </Box>}
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={closeRequest3}>Cancel</Button>
                    <Button onClick={handleSubmit}>Submit</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={connection4} onClose={closeRequest4} maxWidth={"md"} fullWidth={true}>
                <DialogTitle>Step1</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please select one of the model you'd like to modify:
                    </DialogContentText>
                    
                    <Box sx={{ minHeight: 100, ml: 10, mt: 10 }}>
                      <Box sx={{ display: 'flex', mt: 5 }}>
                        <Typography variant="h7">Select one of your request:</Typography>
                        <FormControl variant= "standard" sx={{ ml: 3, mt: -1 }}>
                          <Select native defaultValue="" label="model" disableUnderline
                              theme={theme}
                              sx={{
                                  borderRadius: 25,
                                  backgroundColor: theme.palette.background.default,
                                  padding: "6px 15px",
                              }}
                              value={modelSelected}
                              onChange={(e) => {setModelSelected(e.target.value)}}>
                              
                              <option value="">Your Models:</option>
                              {instance?.map((row) => (
                                  <option value={row.data.modelId}>{row.data.name}</option>
                              ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={closeRequest4}>Cancel</Button>
                    <Button onClick={handleNext3}>Next</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={connection5} onClose={closeRequest5} maxWidth={"md"} fullWidth={true}>
                <DialogTitle>Step2</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please change the values that you'd like to modify:
                    </DialogContentText>
                    
                    <Box sx={{ minHeight: 100, ml: 10, mt: 10 }}>
                      <Box sx={{ display: 'flex', mt: 5 }}>
                        <Typography variant="h7">Select another model:</Typography>
                        <FormControl variant= "standard" sx={{ ml: 3, mt: -1 }}>
                          <Select native defaultValue="" label="model" disableUnderline
                              theme={theme}
                              sx={{
                                  borderRadius: 25,
                                  backgroundColor: theme.palette.background.default,
                                  padding: "6px 15px",
                              }}
                              value={modify1}
                              onChange={(e) => {setModify1(e.target.value)}}>
                              
                              <option value="">Active Models:</option>
                              <option value="Climate Risk Modelling (T&P)">Climate Risk Modelling (T&P)</option>
                              <option value="Investment Decision Modelling">Investment Decision Modelling</option>
                              <option value="Construction Material Selection & Procurement">Construction Material Selection & Procurement</option>
                              <option value="Customized Building Automation">Customized Building Automation</option>
                              <option value="Retrofit Evaluation">Retrofit Evaluation</option>
                              <option value="DER Deployment Feasibility	">DER Deployment Feasibility	</option>
                              <option value="Tenant Sentiment Analysis">Tenant Sentiment Analysis</option>
                              <option value="Lease Pricing Prediction	">Lease Pricing Prediction	</option>
                              <option value="Retrofit Analysis">Retrofit Analysis</option>
                              
                          </Select>
                        </FormControl>
                      </Box>

                      <Box sx={{ display: 'flex', mt: 5 }}>
                        <Typography variant="h7">Select another scientist if needed:</Typography>
                        <FormControl variant= "standard" sx={{ ml: 3, mt: -1 }}>
                          <Select native defaultValue="" label="model" disableUnderline
                              theme={theme}
                              sx={{
                                  borderRadius: 25,
                                  backgroundColor: theme.palette.background.default,
                                  padding: "6px 15px",
                              }}
                              value={modify2}
                              onChange={(e) => {setModify2(e.target.value)}}>

                              <option value=""></option>
                              {expert?.map((row) => (
                                <option value={row.data.name}>{row.data.name}</option>
                              ))}
                          </Select>
                        </FormControl>
                      </Box>
                      {modify2 && 
                            <Box>
                              {specific2?.map((row) => (
                                <FormControl>
                                <Typography variant="h7">Talent: {row.data.talent}</Typography>
                                <Typography variant="h7">Work year: {row.data.year} year</Typography>
                                <Typography variant="h7">Age: {row.data.age}</Typography>
                                <Typography variant="h7">background: {row.data.college}</Typography>
                                <Typography variant="h7">LinkedIn: <a href={row.data.linkedin}>{row.data.linkedin}</a></Typography>
                                </FormControl>
                              ))}
                            </Box>}
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={closeRequest5}>Cancel</Button>
                    <Button onClick={handleModifySubmit}>Submit</Button>
                </DialogActions>
            </Dialog>
          </Box>
          )}
    </Box>
  );
}